var register = require('../../core/component').registerComponent;

module.exports.Component = register('debug', {
  schema: {default: true}
});



// WEBPACK FOOTER //
// ./node_modules/aframe/src/components/scene/debug.js